/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../client.ts';
import type { RequestConfig, ResponseErrorConfig } from '../../client.ts';
import type {
  TelegramAuthPhoneControllerAuthorizeByPhoneMutationRequest,
  TelegramAuthPhoneControllerAuthorizeByPhoneMutationResponse,
  TelegramAuthPhoneControllerAuthorizeByPhone401,
  TelegramAuthPhoneControllerAuthorizeByPhone403,
} from '../types/TelegramAuthPhoneControllerAuthorizeByPhone.ts';

function getTelegramAuthPhoneAuthorizeByPhoneUrl() {
  const res = { method: 'POST', url: `/api/telegram/auth/phone/login` as const };
  return res;
}

/**
 * {@link /api/telegram/auth/phone/login}
 */
export async function telegramAuthPhoneAuthorizeByPhone(
  data: TelegramAuthPhoneControllerAuthorizeByPhoneMutationRequest,
  config: Partial<RequestConfig<TelegramAuthPhoneControllerAuthorizeByPhoneMutationRequest>> & {
    client?: typeof fetch;
  } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const requestData = data;

  const res = await request<
    TelegramAuthPhoneControllerAuthorizeByPhoneMutationResponse,
    ResponseErrorConfig<
      TelegramAuthPhoneControllerAuthorizeByPhone401 | TelegramAuthPhoneControllerAuthorizeByPhone403
    >,
    TelegramAuthPhoneControllerAuthorizeByPhoneMutationRequest
  >({
    method: 'POST',
    url: getTelegramAuthPhoneAuthorizeByPhoneUrl().url.toString(),
    data: requestData,
    ...requestConfig,
  });
  return res.data;
}
